import React from 'react';
import { Megaphone } from 'lucide-react';
import { PersistedWorkflow } from '@cotera/sdk/core';
import { Text } from '@cotera/client/app/components/ui';
import type {
  WorkflowNodeRenderStrategy,
  WorkflowNodeViewData,
} from '../types';
import { parseWorkflowNodeData } from '@cotera/api';

const { WorkflowNodeType } = PersistedWorkflow;

function summarize(node: WorkflowNodeViewData): string | undefined {
  // Invalid means the event name is blank, which is exactly when there is
  // nothing to summarize.
  const parsed = parseWorkflowNodeData('emit-event', node.data);
  if (parsed.t === 'invalid') {
    return undefined;
  }
  const { eventName, payloadBindings } = parsed.data;
  const bindingCount =
    payloadBindings === undefined ? 0 : Object.keys(payloadBindings).length;
  if (bindingCount === 0) {
    return eventName;
  }
  return `${eventName} · ${bindingCount} field${bindingCount === 1 ? '' : 's'}`;
}

export const emitEventNodeStrategy: WorkflowNodeRenderStrategy = {
  nodeType: WorkflowNodeType.EmitEvent,
  accent: 'control',
  badge: 'Emit event',
  getTitle: () => 'Emit event',
  getDescription: () =>
    'Publish a named event for other workflows to listen to',
  renderIcon: () => <Megaphone className="h-4 w-4" />,
  renderBody: (node) => {
    const summary = summarize(node);
    return (
      <Text.Caption className="text-muted-foreground block truncate">
        {summary ?? 'No event name configured'}
      </Text.Caption>
    );
  },
};
